import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

import COLORS from '@mlb/react-patterns/style/universal.color.ts';
import ContentCard  from '@mlb/react-patterns/components/ContentCard/contentCard.tsx';
import Duration from './ReelDuration';

import { DateUtils } from 'bdvp-common/src/utils';

import {
    useMediaConfigReel,
    useLang,
} from 'bdvp-common/src/hooks/config';

const ReelCard = forwardRef((props, ref) => {

    const {
        mediaPlayback,
        orientation,
        isLoading,
        optionsMenu,
        className,
        reel,
        imgSizes,
    } = props;

    const config = useMediaConfigReel();
    const lang = useLang();

    if(isLoading) return (
        <ContentCard
            className={className}
            orientation={orientation}
            isLoading={isLoading}
            headlineWidth={'auto'}
            imageProps={{
                fixAspect: true,
                ratio: '16:9',
                borderRadius: '6px',
            }}
        />
    );

    const blurb = mediaPlayback.blurb ?? '';
    const date = mediaPlayback.date ?? '';
    const formattedDate = DateUtils.formatDate(date, lang);
    const feeds = mediaPlayback.feeds ?? [];
    const imageCuts = feeds[0]?.image?.cuts ?? [];
    const imageAlt = feeds[0]?.image?.altText ?? '';
    const imageSrc = imageCuts[0]?.src ?? '';
    const errorImageSrc = config.errorImageSrc ?? '';
    const imageSrcSet = imageCuts.map((img) => `${img.src} ${img.width}w`).join(', ');

    const imageProps = {
        src: imageSrc,
        srcset: imageSrcSet,
        errorImageSrc: errorImageSrc,
        alt: imageAlt,
        fixAspect: true,
        ratio: '16:9',
        width: '100%',
        height: '100%',
        borderRadius: '6px',
        backgroundColor: COLORS.mlbGrey7,
        sizes: imgSizes,
    };

    const videoProps = {
        duration: <Duration mediaId={mediaPlayback.id} reel={reel}/>,
        hideIcon: true,
        live: false,
    };

    return (
        <ContentCard
            className={className}
            headline={blurb}
            publishDate={formattedDate}
            imageProps={imageProps}
            orientation={orientation}
            videoProps={videoProps}
            ref={ref}
            optionsComponent={
                optionsMenu
            }
        />
    );

});

ReelCard.propTypes = {
    orientation: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    className: PropTypes.string,
    mediaPlayback: PropTypes.object,
    optionsMenu: PropTypes.element,
    reel: PropTypes.object,
    imgSizes: PropTypes.string,
};

ReelCard.defaultProps = {
    isLoading: false,
    className: undefined,
    mediaPlayback: {},
    optionsMenu: undefined,
    reel: {},
    imgSizes: '',
};

export default ReelCard;
